import { endOfISOWeek, Interval, isValid, parse, startOfISOWeek } from 'date-fns';

/**
 * @name parseIsoWeekToInterval
 * @category Common Helpers
 * @summary Parse ISO 8601 week notation to date-fns interval
 *
 * @description
 * Parse the given string in ISO 8601 week notation format (YYYY-Www) and return an Interval object.
 *
 * @param notation - ISO 8601 week notation string (e.g., '2026-W04')
 * @returns interval object representing the start and end of the ISO week
 *
 * @example
 * // Convert string '2026-W04' to interval:
 * const result = parseIsoWeekToInterval('2026-W04')
 * //=>
 * {
 *   start: Mon Jan 19 2026 00:00:00 ...,
 *   end: Sun Jan 25 2026 23:59:59 ...
 * }
 */
export function parseIsoWeekToInterval(notation: string): Interval<Date, Date> {
  let date = parse(notation, "RRRR-'W'II", new Date());

  if (!isValid(date)) {
    date = parse(notation, "RRRR'W'II", new Date());
  }

  return {
    start: startOfISOWeek(date),
    end: endOfISOWeek(date),
  };
}
